import feather from "feather-icons";

function initComponentsAfterLoad(parentNode) {
  console.log('initComponentsAfterLoad', Date.now())
  feather.replace();

  if(parentNode) {
    htmx.process(document.body);
    M.Modal.init(parentNode.querySelectorAll('.modal:not(.no-autoinit)'));
  } else {

    // activity duplicate
    $('.activity-duplicate-selected-organization').on('change', function(e) {
      var _this = $(this);
      var modal = _this.parents('.modal');
      var selected_org = modal.find('.activity-duplicate-selected-organization').val();
      var projects_select = modal.find('.activity-duplicate-selected-project');

      // dynamically load the HTML SELECT
      projects_select.empty();
      $.ajax({
        url: '/api/v1/projects?ordering=created_at&organization=' + selected_org,
        success: function(data) {
          if(data.results.length == 0) {
            projects_select.prop('disabled', true);
            projects_select.append($('<option>', {
              text: "(no projects)"
            }));
          } else {
            projects_select.prop('disabled', false);
            projects_select.append($('<option>', {
              text: "(select project)"
            }));
            $.each(data.results, function(index, project) {
              projects_select.append($('<option>', {
                value: project.id,
                text: project.name
              }));
            });
          }
        }
      });
    });

    $('.activity-duplicate-button').on('click', function(e) {
      var _this = $(this);
      _this.css('opacity', 0.5);
      _this.prop('disabled', true);

      var modal = _this.parents('.modal');
      var href = _this.data('href');
      var selected_org = modal.find('.activity-duplicate-selected-organization').val();
      var selected_project = modal.find('.activity-duplicate-selected-project').val();
      href += "?project_id="+ selected_project;
      if(selected_org) href += "&organization_id="+ selected_org;
      modal.find('.modal-error').text('');

      $.ajax({
        url: href,
        success: function() {
          Turbolinks.visit(window.location.href)
          // M.Modal.getInstance(modal).close();
        },
        error: function(data) {
          modal.find('.modal-error').text('Error: ' + data.responseText);
          _this.prop('disabled', false);
          _this.css('opacity', 1.0);
        }
      });
    });
  }
}

window.initComponentsAfterLoad = initComponentsAfterLoad
